import { Typography, Box, Grid, Stack } from "@mui/material";

const tryParseJson = (value) => {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export default function MarketplaceFeesSettings({ rawData }) {
  const parsed = tryParseJson(rawData);

  if (!parsed || typeof parsed !== "object") {
    return (
      <Typography color="error" variant="body2">
        Invalid or empty Marketplace Fees JSON
      </Typography>
    );
  }
  return (
    <Stack spacing={1} sx={{ p: 2, pt: 1, flex: 1, justifyContent: 'center' }}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <Typography variant="body2" sx={{
              color: 'text.secondary',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              mb: 0.5,
            }}>
              Listing Fee
            </Typography>
            <Typography variant="subtitle2" sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '1rem',
            }}>
              {rawData ? `${String(rawData.listingFee)}` : "N/A"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <Typography variant="body2" sx={{
              color: 'text.secondary',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              mb: 0.5,
            }}>
              Sell Fee
            </Typography>
            <Typography variant="subtitle2" sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '1rem',
            }}>
              {rawData ? `${String(rawData.sellFeePct)}%` : "N/A"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  )
}
